import React, { useState, Fragment, useRef, Suspense, useCallback, useContext, useMemo, useEffect } from "react";
import "./gliFormv2.css";
import HeaderSection from "./headerSection/HeaderSection";
import NextSection from "./nextHeaderSection/NextSection";

import TermsCondition from "./footerTerms/TermsCondition";
// import BeneficaryDetails from "./primaryBeneficary/BeneficaryDetails";
import PlanActions from "../../../../../shared/enrollment/planActions/PlanActions";
import { PlanFormProps } from "../../../../../../types/components/enrollmentProps.types";
import { AuthContext, GroupEnrollmentContext, GroupOwnerContext, PaycheckContext } from "../../../../../../contexts";
import { getCurrentDate, manualDateComparator } from "../../../../../../utils/commonFunctions/date";
import {
	BeneficieryDetails,
	BeneficieryPayload,
	CommonDetails,
	GLICommonDetails
} from "../../../../../../types/enrollment.types";
import {
	AddEnrollmentPayload,
	AddGLIEnrollmentPayload,
	AddKSOPEnrollmentPayload
} from "../../../../../../utils/api/enrollment/enrollment";
import { api } from "../../../../../../utils/api";
import { useHistory, useLocation } from "react-router-dom";
import { CustomFormDialogType } from "../../../../../../types/components/dialogProps.types";
import {
	generateGLIWaiveEnrollmentPayload,
	generateKsopWaiveEnrollmentPayload
} from "../../../../../../utils/commonFunctions/groupEnrollment/enrollment";
import { LazyCustomFormDialog } from "../../../../../shared";
import { trackPromise } from "react-promise-tracker";
import BeneficaryDetails from "./BeneficaryDetails/BeneficaryDetails";

interface CommonBeneficiaryProps {
	id: number;
	name: string;
	date_of_birth: string;
	relationship: string;
	SSN: string;
	address: string;
	percentage: string;
	type: string;
}

const GLIFormv2 = ({ getEnrollmentInitData, isActiveEnrollment, openEnrollment }: PlanFormProps) => {
	const [waiveReason, setWaiveReason] = useState("");
	const [isWaiveEnrollmentTriggered, setIsWaiveEnrollmentTriggered] = useState(false);
	const { member } = useContext(AuthContext);
	const location = useLocation();
	const { setCurrentEnrollment, deleteCurrentEnrollment } = useContext(GroupEnrollmentContext);
	const history = useHistory();
	const { paycheck } = useContext(PaycheckContext);

	const [beneficieryDetailsList, setBeneficieryDetailsList] = useState<CommonBeneficiaryProps[]>([
		{
			id: 1,
			name: "",
			date_of_birth: "",
			relationship: "",
			SSN: "",
			address: "",
			percentage: "",
			type: ""
		}
	]);

	const handleWaiveReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setWaiveReason(value);
	};

	const [customFormDialogProps, setCustomFormDialogProps] = useState<CustomFormDialogType>();
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	const { groupOwner } = useContext(GroupOwnerContext);

	const handleWaiveEnrollment = useCallback(async () => {
		if (member === null || openEnrollment === null) {
			return;
		}
		const { standardDetails, commonDetails } = generateGLIWaiveEnrollmentPayload(
			member,
			openEnrollment,
			waiveReason
		);
		if (isActiveEnrollment) {
			// console.log("isActiveEnrollment", isActiveEnrollment);
			commonDetails.enrollment_status = "WAIVED - WAITING FOR APPROVAL";
			// debugger;
		}
		const enrollmentPayload: AddEnrollmentPayload = {
			standard_details: standardDetails,
			common_details: { ...commonDetails, agent_id: groupOwner && groupOwner._id ? groupOwner._id : null }
		};
		const response = await trackPromise(api.enrollment.addEnrollment(enrollmentPayload));
		if (response) {
			getEnrollmentInitData(false);
		}
		const step = urlSearchParams.get("step");
		history.push(`?step=${step}&stage=0`);
	}, [
		getEnrollmentInitData,
		groupOwner,
		history,
		isActiveEnrollment,
		member,
		openEnrollment,
		urlSearchParams,
		waiveReason
	]);

	const handleWaiveButtonClick = useCallback(() => {
		setCustomFormDialogProps(
			Object.assign({}, customFormDialogProps, {
				openDialog: true,
				title: "Are you sure want to waive this enrollment?",
				textfields: [
					{
						label: "Waive Reason",
						onChange: handleWaiveReasonChange,
						value: waiveReason,
						placeholder: "Enter your reason for waive"
					}
				],
				actions: [
					{
						label: "Cancel",
						callback: () =>
							setCustomFormDialogProps(Object.assign({}, customFormDialogProps, { openDialog: false }))
					},
					{
						label: "Yes",
						callback: () => {
							setCustomFormDialogProps(
								Object.assign({}, customFormDialogProps, {
									openDialog: false
								})
							);
							// handleWaiveEnrollment();
							setIsWaiveEnrollmentTriggered(true);
						}
					}
				]
			})
		);
	}, [customFormDialogProps, waiveReason]);

	const validateGLIBeneficieryDetails = useCallback((beneficiery, type) => {
		// console.log("Beneficiery", beneficiery);
		// console.log("Type", type);
		let sum = 0;
		let _dob;
		let isValid = true;

		let primary_found = false;
		let contingent_found = false;
		let sum_contingent_beneficiery = 0;

		let is_alert = false;

		for (let i = 0; i < beneficiery.length; i++) {
			const { name, date_of_birth, relationship, percentage, address, SSN, type } = beneficiery[i];
			if (type == "primary_beneficiery") {
				primary_found = true;
				sum = sum + parseInt(percentage);
			}
			if (type == "contingent_beneficiery") {
				contingent_found = true;
				sum_contingent_beneficiery = sum_contingent_beneficiery + parseInt(percentage);
			}
			if (
				name !== "" &&
				date_of_birth !== "" &&
				relationship !== "" &&
				percentage !== "" &&
				address !== "" &&
				SSN !== "" &&
				type !== ""
			) {
				const cleanSSN = SSN.replace(/-/g, "");
				if (!/^\d{9}$/.test(cleanSSN)) {
					alert(`Invalid SSN in ${type}.`);
					isValid = false;
					is_alert = true;
					return isValid;
				}
				_dob = date_of_birth.split("/");
				if (_dob[2].length < 4) {
					alert(`Invalid year in ${type}. Valid date format MM/DD/YYYY`);
					isValid = false;
					is_alert = true;
					return isValid;
				}
			} else if (
				name === "" ||
				date_of_birth === "" ||
				relationship === "" ||
				percentage === "" ||
				address === "" ||
				SSN === "" ||
				type == ""
			) {
				isValid = false;
				is_alert = true;
				alert(`Please fill all the field ${type}`);
				break;
			} else {
				isValid = false;
				is_alert = true;
				alert(`Please fill all the field ${type}`);
				break;
			}
		}
		// console.log("Beneficiery", beneficiery);
		// console.log("Type", type);
		if (!primary_found && !is_alert) {
			isValid = false;
			alert("You must have at least one primary beneficiery");
			return isValid;
		}
		if (sum_contingent_beneficiery !== 100 && sum_contingent_beneficiery !== 0 && contingent_found && !is_alert) {
			isValid = false;
			alert("Total percentage must equal to 100 contingent_found");
			return isValid;
		}
		if (sum !== 100 && sum !== 0 && primary_found && !is_alert) {
			isValid = false;
			alert("Total percentage must equal to 100 primary_found");
			return isValid;
		}
		return isValid;
	}, []);

	const generateBeneficieryPayload = useCallback((beneficiery: BeneficieryDetails[]): BeneficieryPayload[] => {
		const beneficieryPayload: BeneficieryPayload[] = [];
		beneficiery.forEach((eachBeneficiery: BeneficieryDetails) => {
			const { name, SSN, relationship, date_of_birth, address, percentage } = eachBeneficiery;
			beneficieryPayload.push({
				name,
				SSN: SSN.replace("/g/-", ""),
				relationship,
				date_of_birth,
				address,
				percentage: Number(percentage)
			});
		});
		return beneficieryPayload;
	}, []);

	const handleActivateButtonClick = useCallback(async () => {
		const contigentBeneficiaries = beneficieryDetailsList.filter(
			(benficiary: any) => benficiary.type == "contingent_beneficiery"
		);
		const primaryBeneficiaries = beneficieryDetailsList.filter(
			(benficiary: any) => benficiary.type == "primary_beneficiery"
		);
		// primaryBeneficiaries.map;
		// console.log("primaryBeneficiaries==>", contigentBeneficiaries);
		// console.log("primaryBeneficiaries==>", primaryBeneficiaries);

		const isPrimaryBeneficieryDetailsValid = validateGLIBeneficieryDetails(beneficieryDetailsList, "primary");
		if (isPrimaryBeneficieryDetailsValid === false) {
			return;
		}

		// const isContingnatBeneficieryDetailsValid = validateGLIBeneficieryDetails(
		// 	primaryBeneficiaries,
		// 	"contignant"
		// );
		// if (isContingnatBeneficieryDetailsValid === false) {
		// 	return;
		// }

		if (member === null || openEnrollment === null || paycheck === null) {
			return;
		}

		// const primary_beneficiery = generateBeneficieryPayload(beneficieryDetailsList);
		// const contingent_beneficiery = generateBeneficieryPayload(contingentBeneficiery);

		// const primaryBeneficiariesRemoveType = primaryBeneficiaries.map(
		// 	({ type, ...primaryBeneficiary }) => primaryBeneficiary
		// );
		// const contigentBeneficiariesRemoveType = contigentBeneficiaries.map(
		// 	({ type, ...contigentBeneficiary }) => contigentBeneficiary
		// );

		// const primaryBeneficiariesRemoveType = primaryBeneficiaries.map(({ type, ...primaryBeneficiary }) => {
		// 	return {
		// 		...primaryBeneficiary,
		// 		percentage: Number(primaryBeneficiary.percentage)
		// 	};
		// });

		// const contigentBeneficiariesRemoveType = contigentBeneficiaries.map(({ type, ...contigentBeneficiary }) => {
		// 	return {
		// 		...contigentBeneficiary,
		// 		percentage: Number(contigentBeneficiary.percentage)
		// 	};
		// });

		// // console.log("primaryBeneficiariesRemoveType==>", primaryBeneficiariesRemoveType);

		const primary_beneficiery = primaryBeneficiaries.map((item: any) => {
			delete item["type"];
			return item;
		});
		const contingent_beneficiery = contigentBeneficiaries.map((item: any) => {
			delete item["type"];
			return item;
		});

		const currentDate = new Date() as unknown as string;
		const planStartDate = openEnrollment.plan.start_date; // -1 or 0
		const planDateComparison: number = manualDateComparator(planStartDate, currentDate);

		const effectiveDate = openEnrollment.plan.auto_approve
			? planDateComparison === -1 || planDateComparison === 0
				? getCurrentDate()
				: null
			: null;

		const enrollmentCommonDetails: GLICommonDetails = {
			agent_id: groupOwner && groupOwner._id ? groupOwner._id : null,
			location_number: member.location.location_number,
			location_name: member.location.location_name,
			group_number: member.group_number,
			group_name: member.group.name,
			plan_object_id: openEnrollment.plan._id,
			plan_code: openEnrollment.plan.plan_code,
			plan_name: openEnrollment.plan.plan_name,
			base_plan_name: openEnrollment.plan.plan_name,
			insured_object_id: member._id,
			insured_SSN: member.SSN,
			writing_number: 0,
			unenrolled_reason: null,
			waive_reason: null,
			termination_reason: null,
			enrollment_date: getCurrentDate(),
			effective_date: null,
			termination_date: null,
			open_enrollment_id: openEnrollment._id,
			total_premium: 0,
			primary_beneficiery,
			contingent_beneficiery
		};
		const enrollmentPayload: AddGLIEnrollmentPayload = {
			common_details: enrollmentCommonDetails,
			standard_details: [
				{
					member_object_id: member._id,
					member_SSN: member.SSN,
					coverage_code: "EE",
					premium_amount: 0,
					is_tobacco: false
				}
			]
		};
		const response = await api.enrollment.addEnrollment(enrollmentPayload);
		if (response) {
			const step = urlSearchParams.get("step");
			getEnrollmentInitData(false);
			history.push(`?step=${step}&stage=0`);
		}
	}, [
		beneficieryDetailsList,
		validateGLIBeneficieryDetails,
		member,
		openEnrollment,
		paycheck,
		groupOwner,
		urlSearchParams,
		getEnrollmentInitData,
		history
	]);

	const handleAddBeneficiary = useCallback(async (beneficiaries: CommonBeneficiaryProps[]) => {
		setBeneficieryDetailsList(beneficiaries);
	}, []);

	useEffect(() => {
		if (openEnrollment) {
			// setCurrentEnrollment(
			// 	Object.assign(
			// 		{},
			// 		{
			// 			plan_name: openEnrollment.plan.plan_name,
			// 			status: "Current",
			// 			premium_amount: 0
			// 		}
			// 	)
			// );
		}
	}, [openEnrollment, setCurrentEnrollment]);

	useEffect(() => {
		if (isWaiveEnrollmentTriggered) {
			handleWaiveEnrollment();
			setIsWaiveEnrollmentTriggered(false); // Reset the trigger
		}
	}, [isWaiveEnrollmentTriggered, handleWaiveEnrollment]);

	return (
		<div className="gli-form-container">
			<Suspense fallback={<div />}>
				{customFormDialogProps ? <LazyCustomFormDialog customFormDialogProps={customFormDialogProps} /> : null}
			</Suspense>
			<div className="gli-form-actual-container">
				<HeaderSection isPrintable={false} />
				<NextSection isPrintable={false} />
				<BeneficaryDetails
					beneficiary={beneficieryDetailsList}
					handleAddBeneficiary={handleAddBeneficiary}
					isPrintable={false}
				/>
				<TermsCondition isPrintable={false} />
			</div>
			<PlanActions
				waiveButtonCallback={handleWaiveButtonClick}
				activateButtonCallback={handleActivateButtonClick}
			/>
		</div>
	);
};

export default GLIFormv2;
